module.exports = __webpack_public_path__ + "static/media/Linearicons-Free.3267b0d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/architect/components/icons/linearicons/Linearicons-Free.svg
// module id = 326
// module chunks = 0